import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, mergeProps as _mergeProps, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14ae9ca6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold fs-6" }, " File Berita (Max: 5Mb) ", -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-10" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload text-white" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Upload ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "mp4 Only!", -1))
const _hoisted_11 = {
  key: 0,
  class: "col-md-6 mt-6"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6" }, null, -1))
const _hoisted_13 = { class: "d-flex gap-2" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Copied ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-lg" }, null, -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-7 col-sm-12" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12 mt-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold fs-6" }, " Judul Berita ", -1))
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "col-12 mt-2" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold fs-6" }, " Nama Stasiun TV ", -1))
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "col-12 mt-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold fs-6" }, " Program ", -1))
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "col-12 mt-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6" }, " Durasi Video (Detik) ", -1))
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "col-12 mt-2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6" }, "Emotion", -1))
const _hoisted_40 = { class: "d-flex gap-2" }
const _hoisted_41 = ["for"]
const _hoisted_42 = { class: "svg-icon svg-icon-2x me-2" }
const _hoisted_43 = {
  key: 0,
  class: "far fa-meh-blank fs-2x text-primary"
}
const _hoisted_44 = {
  key: 1,
  class: "far fa-grin-squint text-success fs-2x"
}
const _hoisted_45 = {
  key: 2,
  class: "far fa-flushed text-warning fs-2x"
}
const _hoisted_46 = {
  key: 3,
  class: "far fa-sad-tear text-complete fs-2x"
}
const _hoisted_47 = {
  key: 4,
  class: "far fa-angry text-complete fs-2x"
}
const _hoisted_48 = { class: "d-block fw-bold text-start" }
const _hoisted_49 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_50 = { class: "fv-plugins-message-container" }
const _hoisted_51 = { class: "fv-help-block" }
const _hoisted_52 = { class: "col-md-5 col-sm-12" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-12 mt-2" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold fs-6" }, " Jenis Data ", -1))
const _hoisted_56 = { class: "fv-plugins-message-container" }
const _hoisted_57 = { class: "fv-help-block" }
const _hoisted_58 = { class: "col-12 mt-2" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tanggal Berita"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Tanggal dalam GMT+7"
  })
], -1))
const _hoisted_60 = { class: "fv-plugins-message-container" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { class: "col-12 mt-2" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6" }, " Jurnalis ", -1))
const _hoisted_64 = { class: "fv-plugins-message-container" }
const _hoisted_65 = { class: "fv-help-block" }
const _hoisted_66 = { class: "col-12 mt-2" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold fs-6" }, " AD Value ", -1))
const _hoisted_68 = { class: "fv-plugins-message-container" }
const _hoisted_69 = { class: "fv-help-block" }
const _hoisted_70 = { class: "col-12 mt-2" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fw-bold fs-6" }, "Sentimen", -1))
const _hoisted_72 = { class: "d-flex gap-2" }
const _hoisted_73 = ["for"]
const _hoisted_74 = { class: "svg-icon svg-icon-2x me-5" }
const _hoisted_75 = {
  key: 0,
  class: "far fa-smile fs-2x text-success"
}
const _hoisted_76 = {
  key: 1,
  class: "far fa-meh text-primary fs-2x"
}
const _hoisted_77 = {
  key: 2,
  class: "far fa-frown text-danger fs-2x"
}
const _hoisted_78 = { class: "d-block fw-bold text-start" }
const _hoisted_79 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_80 = { class: "fv-plugins-message-container" }
const _hoisted_81 = { class: "fv-help-block" }
const _hoisted_82 = { class: "row mt-3" }
const _hoisted_83 = { class: "col-12" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold fs-6" }, " Konten Berita ", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-align-justify text-white" }, null, -1))
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" Fix OCR Text ")
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]
const _hoisted_88 = { class: "fv-plugins-message-container" }
const _hoisted_89 = { class: "fv-help-block" }
const _hoisted_90 = { class: "row mt-5" }
const _hoisted_91 = { class: "col-md-12" }
const _hoisted_92 = { class: "d-flex justify-content-between" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Reset Data ", -1))
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = {
  type: "submit",
  ref: "confirm_button",
  class: "btn btn-sm btn-success"
}
const _hoisted_96 = { class: "indicator-label" }
const _hoisted_97 = {
  key: 0,
  class: "bi bi-check-circle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    ref: "form",
    class: "form",
    novalidate: "novalidate",
    onSubmit: _cache[15] || (_cache[15] = ($event: any) => (_ctx.confirmData())),
    "validation-schema": _ctx.form_validator
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Field, {
                type: "hidden",
                name: "file_source",
                class: "form-control form-control-lg",
                placeholder: "File Source",
                modelValue: _ctx.media_tv_data.file_source,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.media_tv_data.file_source) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_upload, {
                ref: "upload",
                class: "upload-demo",
                action: _ctx.upload_file_url,
                headers: _ctx.file_upload_header,
                "on-success": _ctx.setFileUpload,
                "before-remove": _ctx.removeFileUpload,
                "on-remove": _ctx.cekFileSource,
                "on-error": _ctx.errorFileUpload,
                multiple: true,
                accept: "video/mp4,video/x-m4v",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.is_copied = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["action", "headers", "on-success", "before-remove", "on-remove", "on-error"]),
              _hoisted_10
            ]),
            (
              _ctx.media_tv_data.file_source && _ctx.media_tv_data.source == 'media_tv'
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Field, {
                      id: "copy-clipboard",
                      type: "text",
                      name: "link",
                      class: "form-control text-muted",
                      placeholder: "Link Sumber",
                      modelValue: _ctx.media_tv_data.file_source,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.media_tv_data.file_source) = $event)),
                      readonly: ""
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("button", {
                      id: "btn-copy",
                      type: "button",
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.copyText && _ctx.copyText(...args)))
                    }, [
                      (!_ctx.is_copied)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Copy"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_18))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_Field, {
                type: "text",
                name: "title",
                class: "form-control",
                placeholder: "Judul Berita",
                modelValue: _ctx.media_tv_data.title,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.media_tv_data.title) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_ErrorMessage, { name: "title" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_Field, {
                name: "account",
                "aria-autocomplete": "off",
                autocomplete: "off"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_el_select, _mergeProps(field, {
                    filterable: "",
                    placeholder: "Nama Stasiun TV",
                    "allow-create": _ctx.stasiun_options.length == 0,
                    name: "account",
                    modelValue: _ctx.media_tv_data.account,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.media_tv_data.account) = $event)),
                      _ctx.checkADValueFromDuration
                    ],
                    "reserve-keyword": "",
                    loading: _ctx.loading,
                    "remote-method": _ctx.remoteMethodTV,
                    autocomplete: "off",
                    remote: true,
                    class: "d-block"
                  }), {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stasiun_options, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item._id,
                          value: item._id,
                          onClick: ($event: any) => (_ctx.changeAccount(item))
                        }, null, 8, ["label", "value", "onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1040, ["allow-create", "modelValue", "loading", "remote-method", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_ErrorMessage, { name: "account" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode(_component_Field, {
                name: "program",
                "aria-autocomplete": "off",
                autocomplete: "off"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_el_select, _mergeProps(field, {
                    filterable: "",
                    placeholder: "Program",
                    "allow-create": "",
                    name: "program",
                    modelValue: _ctx.media_tv_data.program,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.media_tv_data.program) = $event)),
                    "reserve-keyword": "",
                    loading: _ctx.loading,
                    "remote-method": _ctx.remoteMethod,
                    autocomplete: "off",
                    remote: true,
                    class: "d-block"
                  }), {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.media_options, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.nama,
                          value: item.nama
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1040, ["modelValue", "loading", "remote-method"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_ErrorMessage, { name: "program" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_component_Field, {
                type: "number",
                name: "duration",
                class: "form-control",
                placeholder: "Durasi Video",
                modelValue: _ctx.media_tv_data.duration,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((_ctx.media_tv_data.duration) = $event)),
                  _ctx.checkADValueFromDuration
                ]
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_ErrorMessage, { name: "duration" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.emotion, (emotion) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: emotion.value
                  }, [
                    _createVNode(_component_Field, {
                      class: "btn-check",
                      name: "emotion",
                      id: 'emotion' + emotion.title,
                      onClick: ($event: any) => (_ctx.setEmotion(emotion.value))
                    }, null, 8, ["id", "onClick"]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-2 d-flex align-items-center", 
                    _ctx.media_tv_data.emotion == emotion.value ? 'check-active' : ''
                  ]),
                      for: 'emotion' + emotion.title
                    }, [
                      _createElementVNode("span", _hoisted_42, [
                        (emotion.value === '0')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_43))
                          : (emotion.value === '1')
                            ? (_openBlock(), _createElementBlock("i", _hoisted_44))
                            : (emotion.value === '2')
                              ? (_openBlock(), _createElementBlock("i", _hoisted_45))
                              : (emotion.value === '3')
                                ? (_openBlock(), _createElementBlock("i", _hoisted_46))
                                : (_openBlock(), _createElementBlock("i", _hoisted_47))
                      ]),
                      _createElementVNode("span", _hoisted_48, [
                        _createElementVNode("span", _hoisted_49, _toDisplayString(emotion.title), 1)
                      ])
                    ], 10, _hoisted_41)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_ErrorMessage, { name: "emotion" })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createVNode(_component_Field, {
                name: "jenis_data",
                "aria-autocomplete": "off",
                autocomplete: "off"
              }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_el_select, _mergeProps(field, {
                    filterable: "",
                    placeholder: "Jenis Data",
                    name: "jenis_data",
                    modelValue: _ctx.media_tv_data.jenis_data,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.media_tv_data.jenis_data) = $event)),
                    class: "d-block"
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Berita",
                        value: "berita"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Iklan",
                        value: "iklan"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Running Text",
                        value: "running_text"
                      })
                    ]),
                    _: 2
                  }, 1040, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_component_ErrorMessage, { name: "jenis_data" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createVNode(_component_Field, { name: "date" }, {
                default: _withCtx(({ handleBlur, handleChange }) => [
                  _createVNode(_component_el_form, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "dueDate",
                        class: "mb-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            style: {"width":"100% !important"},
                            onBlur: handleBlur,
                            onChange: handleChange,
                            modelValue: _ctx.media_tv_data.date,
                            "onUpdate:modelValue": [
                              _cache[9] || (_cache[9] = ($event: any) => ((_ctx.media_tv_data.date) = $event)),
                              _ctx.checkADValueFromDuration
                            ],
                            placeholder: "Tanggal Berita",
                            format: "YYYY-MM-DD HH:mm:ss",
                            name: "date",
                            type: "datetime"
                          }, null, 8, ["onBlur", "onChange", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_ErrorMessage, { name: "date" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createVNode(_component_Field, {
                type: "text",
                name: "journalist",
                class: "form-control",
                placeholder: "Jurnalis",
                modelValue: _ctx.media_tv_data.journalist,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.media_tv_data.journalist) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createVNode(_component_ErrorMessage, { name: "journalist" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _hoisted_67,
              _createVNode(_component_Field, {
                type: "number",
                name: "ad_value",
                class: "form-control",
                placeholder: "AD Value",
                modelValue: _ctx.media_tv_data.ad_value,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.media_tv_data.ad_value) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_component_ErrorMessage, { name: "ad_value" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _hoisted_71,
              _createElementVNode("div", _hoisted_72, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.sentiment, (sentiment) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: sentiment.value
                  }, [
                    _createVNode(_component_Field, {
                      class: "btn-check",
                      name: "sentiment",
                      id: 'sentiment' + sentiment.title,
                      onClick: ($event: any) => (_ctx.setSentiment(sentiment.value))
                    }, null, 8, ["id", "onClick"]),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-outline btn-outline-dashed btn-outline-default p-2 d-flex align-items-center", 
                    _ctx.media_tv_data.sentiment == sentiment.value
                      ? 'check-active'
                      : ''
                  ]),
                      for: 'sentiment' + sentiment.title
                    }, [
                      _createElementVNode("span", _hoisted_74, [
                        (sentiment.value === '1')
                          ? (_openBlock(), _createElementBlock("i", _hoisted_75))
                          : (sentiment.value === '0')
                            ? (_openBlock(), _createElementBlock("i", _hoisted_76))
                            : (_openBlock(), _createElementBlock("i", _hoisted_77))
                      ]),
                      _createElementVNode("span", _hoisted_78, [
                        _createElementVNode("span", _hoisted_79, _toDisplayString(sentiment.title), 1)
                      ])
                    ], 10, _hoisted_73)
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createVNode(_component_ErrorMessage, { name: "sentiment" })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          _hoisted_84,
          _createVNode(_component_Field, { name: "content" }, {
            default: _withCtx(({ field, content_value }) => [
              _createVNode(_component_el_input, _mergeProps(field, {
                modelValue: _ctx.media_tv_data.content,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.media_tv_data.content) = $event)),
                type: "textarea",
                rows: "5",
                value: content_value
              }), null, 16, ["modelValue", "value"])
            ]),
            _: 1
          }),
          _createElementVNode("a", {
            size: "small",
            class: "btn btn-sm btn-primary mt-2",
            type: "primary",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.convertText && _ctx.convertText(...args)))
          }, _hoisted_87),
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _createVNode(_component_ErrorMessage, { name: "content" })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_90, [
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-warning",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
            }, _hoisted_94),
            _createElementVNode("button", _hoisted_95, [
              _createElementVNode("span", _hoisted_96, [
                (_ctx.is_confirmed)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_97))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.is_confirmed ? "Data Telah Sesuai!" : "Konfirmasi Data"), 1)
              ])
            ], 512)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}